// extracted by mini-css-extract-plugin
export default {"subsectionHeading":"SubsectionTitle_subsectionHeading__8e-ob"};